module.exports = __webpack_public_path__ + "img/client-6--small.png?8f68409fc549a1756336d5d6f1d8e69d";